export class TaskCustomFieldOption {
  id = 0;

  name = '';

  position = 0;

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}

export default TaskCustomFieldOption;
